export default {
    computed: {

        siteData() {
            return this.$store.state.booking.siteData
        },

        bookingData() {
            return this.$store.state.booking.bookingData
        },

        formSelectChoices() {
            return this.$store.state.booking.formSelectChoices
        },

        siteIsLoaded() {
            return this.$store.state.booking.siteIsLoaded
        },

        bookingFinishedSuccessful() {
            return this.$store.state.booking.bookingFinishedSuccessful
        },

        bookingIsChargeable() {
            return this.$store.getters['booking/hasChargeableBookings']
        },

        previewMode: {
            get: function () {
                return this.$store.state.booking.previewMode
            },
            set: function (value) {
                this.$store.commit('booking/setPreviewMode', value)
            }
        },
    },

    methods: {
        /////////////////////////////////////////////////
        //Mutations
        /////////////////////////////////////////////////

        setBookingProp(prop, value, path = null) {
            this.$store.commit('booking/setBookingProp', {prop, value, path})
        },


        /////////////////////////////////////////////////
        //Actions
        /////////////////////////////////////////////////
        fetchSiteData(siteId, loadResourceBookingsOnly = false) {
            return this.$store.dispatch('booking/fetchSiteData', {siteId, loadResourceBookingsOnly})
        },

        sendBooking() {
            return this.$store.dispatch('booking/sendBooking')
        }

    }
}
